define.alias("shared/errors/api-authorization-error", "calendar/errors/api-authorization-error");